import { useState, useEffect } from 'react';
import { FETCH_UNMAPPED_STAKEHOLDERS } from '../../../common/URLs';
import { toast } from 'react-toastify';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { Container, Card, CardContent, Typography, Grid, MenuItem, FormControl, Select, InputLabel, Box } from '@mui/material';
import apiClient from '../../../axios';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';


function UnmappedStakeholderDashboard() {
    const [stakeholderData, setStakeholderData] = useState();
    const [stakeholderType, setStakeholderType] = useState("Grower");

    useEffect(() => {
        getAllWorkflowCount();
    }, [stakeholderType]);

    const getAllWorkflowCount = (type) => {
        loaderService.showLoader();
        apiClient.post(FETCH_UNMAPPED_STAKEHOLDERS,
            {
                "type": [type ? type : stakeholderType]
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setStakeholderData(response.data);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const onTypeChange = (e) => {
        setStakeholderType(e.target.value);
        getAllWorkflowCount(e.target.value);
    }

    const columns = [
        { field: 'urn', headerName: "Stakeholder URN", width: 150 },
        { field: 'name', headerName: "Stakeholder Name", width: 250 },
        { field: 'mobileNo', headerName: "Mobile No.", width: 150 },
        { field: 'emailId', headerName: "Email", width: 200 },
        { field: 'registrationStatus', headerName: "Status", width: 150 },
    ];

    return (
        <Container>
            <Typography variant="h4" gutterBottom> Unmapped Stakeholder </Typography>

            <Grid container spacing={2}>

                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={5} lg={5}>
                                    <FormControl fullWidth required>
                                        <InputLabel>Stakeholder Type</InputLabel>
                                        <Select
                                            label="Stakeholder Type"
                                            value={stakeholderType}
                                            onChange={onTypeChange}
                                        >
                                            <MenuItem value="Grower">Grower</MenuItem>
                                            <MenuItem value="LLE">LLE</MenuItem>
                                            <MenuItem value="HIT">HIT</MenuItem>
                                            <MenuItem value="Transporter">Transporter</MenuItem>
                                            <MenuItem value="InterimStorageOperator">
                                                Interim Storage Operator
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} md={2} lg={2}></Grid>

                                <Grid item xs={12} md={5} lg={5}>
                                    <Grid container spacing={1}>
                                        <Grid item xs={6}>
                                            <Typography variant="subtitle2" color="text.secondary">
                                                Total Records
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                                                {stakeholderData?.totalCount ?? 0}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} lg={12}>
                    <Box sx={{ height: 445, width: '100%', mt: 1 }}>
                        {stakeholderData && (
                            <DataGrid
                                rows={stakeholderData?.stakeHolders ?? []}
                                columns={columns}
                                pageSize={10}
                                getRowId={(row) => row?.id}
                                components={{ Toolbar: QuickSearchToolbar }}
                            />
                        )}
                    </Box>
                </Grid>

            </Grid>
        </Container>
    );
};

export default UnmappedStakeholderDashboard;